export const SHOW_MOBILE_POPOVER = "SHOW_MOBILE_POPOVER";
export const SHOW_MENU = "SHOW_MENU";
export const CLOSE = "CLOSE";
export const OPEN = "OPEN";